export const calculateTooltipPosition = (markerCoordinates, mapWidth, mapHeight, tooltipWidth, tooltipHeight, formWidth, widthMenu, heightHeader, orderTableWidth) => {
	const markerX = markerCoordinates.x
	const markerY = markerCoordinates.y
	const tooltipOffset = 21
	const widthMarkerAndMargin = 35
	const extraSmallMargin = 4
	const extraBigMargin = 24
	const distanceToBottom = (mapHeight + heightHeader) - markerY
	const distanceToLeft = markerX - formWidth - orderTableWidth - widthMenu
	const distanceToRight = (mapWidth + orderTableWidth + widthMenu) - markerX
	let tooltipTop
	let tooltipLeft
	let position
	if (distanceToBottom > tooltipHeight + tooltipOffset && distanceToLeft > tooltipWidth / 2 && distanceToRight > tooltipWidth / 2) {
		tooltipTop = markerY + tooltipOffset / 2
		tooltipLeft = markerX - widthMenu - orderTableWidth - tooltipWidth / 2 + tooltipOffset
		position = 'bottom'
	} else if (distanceToBottom < tooltipHeight + tooltipOffset && distanceToLeft > tooltipWidth / 2 && distanceToRight > tooltipWidth / 2) {
		tooltipTop = markerY - tooltipHeight - tooltipOffset - heightHeader - extraSmallMargin
		tooltipLeft = markerX - widthMenu - orderTableWidth - tooltipWidth / 2 + tooltipOffset
		position = 'top'

	} else if (distanceToLeft > tooltipWidth + tooltipOffset) {
		tooltipLeft = markerX - widthMenu - orderTableWidth - tooltipWidth - tooltipOffset
		tooltipTop = markerY - heightHeader + extraBigMargin - tooltipHeight / 2
		position = 'left'
	} else if (distanceToLeft < tooltipWidth + tooltipOffset) {
		tooltipLeft = markerX - widthMenu - orderTableWidth + widthMarkerAndMargin + tooltipOffset
		tooltipTop = markerY - heightHeader + extraBigMargin - tooltipHeight / 2
		position = 'right'
	}

	return {
		top: `${tooltipTop}px`,
		left: `${tooltipLeft}px`,
		position: `${position}`
	}
}

export const calculateTooltipPositionV2 = (markerCoordinates, mapWidth, mapHeight, tooltipWidth, tooltipHeight, formWidth, heightHeader) => {
	const markerX = markerCoordinates.x
	const markerY = markerCoordinates.y
	const tooltipOffset = 25
	const tooltipTopOffset = 15
	const widthMarkerAndMargin = 35
	const extraSmallMargin = 4
	const extraBigMargin = 30
	const distanceToBottom = (mapHeight + heightHeader) - markerY
	const distanceToLeft = markerX - formWidth
	const distanceToRight = mapWidth - markerX
	let tooltipTop
	let tooltipLeft
	let position
	if (distanceToBottom > tooltipHeight && distanceToLeft > tooltipWidth / 2 && distanceToRight > tooltipWidth / 2) {
		tooltipTop = markerY + tooltipOffset / 2
		tooltipLeft = markerX - tooltipWidth / 2
		position = 'bottom'
	} else if (distanceToBottom < tooltipHeight && distanceToLeft > tooltipWidth / 2 && distanceToRight > tooltipWidth / 2) {
		tooltipTop = markerY - tooltipHeight + tooltipTopOffset - heightHeader - extraSmallMargin
		tooltipLeft = markerX - tooltipWidth / 2
		position = 'top'

	} else if (distanceToLeft > tooltipWidth) {
		tooltipLeft = markerX - tooltipWidth - tooltipOffset
		tooltipTop = markerY - heightHeader + extraBigMargin - tooltipHeight / 2 + tooltipOffset
		position = 'left'
	} else if (distanceToLeft < tooltipWidth) {
		tooltipLeft = markerX + widthMarkerAndMargin
		tooltipTop = markerY - heightHeader + extraBigMargin - tooltipHeight / 2 + tooltipOffset
		position = 'right'
	}

	return {
		top: `${tooltipTop}px`,
		left: `${tooltipLeft}px`,
		position: `${position}`
	}
}
